export var EAgentTaskStatus;
(function (EAgentTaskStatus) {
    EAgentTaskStatus["Pending"] = "pending";
    EAgentTaskStatus["InProgress"] = "in_progress";
    EAgentTaskStatus["Accepted"] = "accepted";
    EAgentTaskStatus["Dispatched"] = "dispatched";
    EAgentTaskStatus["Running"] = "running";
    EAgentTaskStatus["Delayed"] = "delayed";
    EAgentTaskStatus["Completed"] = "completed";
    EAgentTaskStatus["Failed"] = "failed";
    EAgentTaskStatus["Cancelled"] = "cancelled";
    EAgentTaskStatus["Missing"] = "missing";
})(EAgentTaskStatus || (EAgentTaskStatus = {}));
// Editable via PATCH only while not yet dispatched to the agent.
export const AGENT_TASK_EDITABLE_STATUSES = [
    EAgentTaskStatus.Pending,
    EAgentTaskStatus.Delayed
];
// DELETE (cancel) works for any non-terminal status.
export const AGENT_TASK_TERMINAL_STATUSES = [
    EAgentTaskStatus.Completed,
    EAgentTaskStatus.Failed,
    EAgentTaskStatus.Cancelled,
    EAgentTaskStatus.Missing
];
//# sourceMappingURL=agentTasks.types.js.map